import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const useTestBanner = () => {
  const testDetails = useSelector((state) => state.test.testDetails?.data);
  const navigate = useNavigate();
  const { id } = useParams();

  const nextBtnHandler = () => {
    navigate(`/start-test/${id}`);
  };

  return { testDetails, nextBtnHandler };
};

export default useTestBanner;
